import React from 'react';
import { SceneProps } from '../../types/reel';
import { punch, reveal } from '../../utils/reelMath';
import { SceneLayer } from './SceneLayer';
import { TypeText } from './TypeText';
export function ClosingScene({
  time,
  scene
}: SceneProps) {
  const url = reveal(time, scene.start + 1.2, 0.3);
  return <SceneLayer time={time} start={scene.start} end={scene.end} fade={0.5} data-id="element-8" data-mp="pq95rvsy1r0r">
      {({
      p
    }) => <div className="absolute inset-0 flex flex-col items-center justify-center bg-cream text-center" data-id="element-9" data-mp="1ndhrnrwux23a">
          <div style={{
        transform: `scale(${punch(time, scene.start, 0.05, 0.4) + 0.02 * p})`
      }} data-id="element-10" data-mp="1if6lps9onbqc">
            <TypeText time={time} start={scene.start + 0.1} cps={30} segments="I own problems end-to-end." holdCaret className="block text-[108px] font-medium leading-none tracking-[-0.045em] text-ink" data-id="element-11" data-mp="1de0szug0vogt" />
            <p className="mt-12 text-[34px] tracking-[-0.02em] text-ink" style={{
          opacity: url,
          transform: `translateY(${(1 - url) * 10}px)`
        }} data-id="element-12" data-mp="3u2mmx6jtmo1f">
              Let’s talk
            </p>
          </div>
        </div>}
    </SceneLayer>;
}